import styled from "styled-components";

export const ContainerModal = styled.div`
    width: 360px;
    height: 300px;
    border-radius: 8px;
`;
export const TopModal = styled.div`
    height: 62px;
    width: 100%;
    background: var(--color-secondary-gradient);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
        font-size: 16px;
        font-weight: bold;
        color: var(--color-white);
    }
`;
export const BodyModal = styled.div`
    height: 200px;
    width: 100%;
    display: flex;
    gap: 50px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    span {
        font-size: 16px;
        font-weight: bold;
        color: var(--color-latex10);
        width: 80%;
    }
    .container-btn {
        display: flex;
        gap: 20px;
        margin-bottom: -50px;
        button {
            width: 150px;
            height: 46px;
            font-weight: 500;
            font-size: 16px;
            line-height: 150%;
            color: var(--color-white);
            border-radius: 8px;
        }
        .danger {
            background-color: var(--color-danger);
        }
        .success {
            background-color: var(--color-broccoli);
        }
    }
`
